import { acquireAccessToken, MsalAuthenticationTemplate, useAzureAuth } from "@datamole/wds-azure-auth";
import { useEffect, type ReactNode } from "react";

import { config } from "@/config";
import { AuthAzureErrorComponent } from "@/features/auth/AuthGuard/AuthAzureErrorComponent";
import { AZURE_AD_INTERACTION_TYPE } from "@/features/auth/constants";
import { WelcomePage } from "@/pages/WelcomePage";
import { useAppDispatch } from "@/store";
import { authenticate } from "@/store/slices/auth.slice";

type Props = {
    children: ReactNode;
};

export const AuthAzureGuard = ({ children }: Props) => {
    const dispatch = useAppDispatch();
    const { instance, isInteractionInProgress, user } = useAzureAuth();

    useEffect(() => {
        /**
         * If user is already logged in or interaction is in progress, do nothing
         */
        if (user?.idTokenClaims || isInteractionInProgress) return;

        acquireAccessToken(
            {
                scopes: [config.AZURE_AUTH_SCOPE],
            },
            instance,
        );
    }, [instance, user, isInteractionInProgress]);

    // Handle Redux auth state until ADFS is removed
    useEffect(() => {
        if (user?.idTokenClaims) {
            dispatch(authenticate({ authStrategy: "entraId" }));
        }
    }, [dispatch, user]);

    return (
        <MsalAuthenticationTemplate
            interactionType={AZURE_AD_INTERACTION_TYPE}
            errorComponent={AuthAzureErrorComponent}
            loadingComponent={WelcomePage}
        >
            {children}
        </MsalAuthenticationTemplate>
    );
};
